import React from 'react';
import GenericTable from '../general/generic-table';
import { utilService } from "../../services/util-service"

interface EmployeeTableProps {
  data: any; // Array of ComponentItem objects
}

// Functional component to render the array of objects
const EmployeeTable: React.FC<EmployeeTableProps> = ({ data }) => {
  const createMapping = (title: string, location: string[], type: string, trueText?: string, falseText?: string) => {
    return ({
      title,
      location,
      type,
      trueText,
      falseText
    })
  }

  const mapping = [
    createMapping('Entity Name', ['entity','name'], 'string'),
    createMapping('Email', ['email'], 'string'),
    createMapping('First Name', ['firstName'], 'string'),
    createMapping('Last Name', ['lastName'], 'string'),
    createMapping('Created At', ['createdAt'], 'string'),
  ]

  let tableData: any = []
  for (let index = 0; index < data.length; index++) {
    let itemData = []
    for (let i = 0; i < mapping.length; i++) {
      let element: any = {}
      element.title = mapping[i].title;

      element.value = utilService.getCellValue(data[index], mapping[i])

      element.type = mapping[i].type;
      itemData.push(element)
    }
    tableData.push(itemData)
  }
  return (<GenericTable data={tableData} recordName="Users" />);
};

export default EmployeeTable;
